"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import s from "./styles";
import logjs from "@metrojs/logjs";
const log = new logjs("login/page");

import { useLogin } from "./useLogin";
import { providers } from "@lib/client";
import Footer from "@app/footer";
const { useWebAppContext } = providers;

/**
 * ログインページコンポーネント
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Object} props.params - 動的ルートパラメータ
 * @param {Object} props.searchParams - URLのクエリパラメータ
 * @returns {JSX.Element} ログインページのコンポーネント
 */
export default function Page() {
  // コンテキストの使用（ルートは (auth)/login に変更済みのため params はルート由来でない）
  const webAppContext = useWebAppContext();
  const { state, actions, params = {}, searchParams } = webAppContext || {};

  const mode = params?.mode;

  //log.debug(`mode: ${mode}`, { params, searchParams });

  const [isMounted, setIsMounted] = useState(false);
  const [form, formProps] = useLogin();

  // ハイドレーションを無効にする
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Enterキーでログイン
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      formProps.login();
    }
  };

  if (!isMounted) {
    return null;
  }

  return (
    <s.BodyBackground>
      <s.LoginContainer>
        <s.ContentWrapper>
          <s.Header>
            <s.Logo>
              <Image src="/images/do_logo_only.svg" width={300} height={76} alt="DirectOrder" />
            </s.Logo>
          </s.Header>

          <s.Container>
            <s.Main>
              <s.LoginBox>
                <s.LoginForm>
                  <s.LoginTitle>DOS管理システム</s.LoginTitle>
                  <s.LoginContent>
                    <s.LoginTable>
                      <div className="field">
                        {formProps.input_login_id({
                          id: "login_id",
                          maxLength: 16,
                          onKeyPress: handleKeyPress,
                          placeholder: "ログインID",
                        })}
                      </div>
                      <div className="field">
                        {formProps.input_password({
                          id: "password",
                          maxLength: 100,
                          onKeyPress: handleKeyPress,
                          placeholder: "パスワード",
                        })}
                      </div>
                    </s.LoginTable>

                    {form?.error && <s.ErrorMessage>{form?.error}</s.ErrorMessage>}

                    <s.LoginButton
                      onClick={(e) => {
                        e.preventDefault();
                        formProps.login(mode);
                      }}
                      disabled={form?.loading}
                    >
                      {form?.loading ? "ログイン中..." : "ログイン"}
                    </s.LoginButton>
                  </s.LoginContent>
                </s.LoginForm>
              </s.LoginBox>
            </s.Main>
          </s.Container>
        </s.ContentWrapper>

        <Footer />
      </s.LoginContainer>
    </s.BodyBackground>
  );
}
